import { z } from 'zod'
import type { components } from '@/types/api.generated'

// Contact title type from backend API
// The backend no longer exposes CreateAssignmentDto. ContactSummaryDto is
// where the job-title enum lives in the current contract, and it is required
// there rather than optional, so the label record below still has to be total.
export type ContactTitle = components['schemas']['ContactSummaryDto']['title']

// Labels for contact titles (display text only - values come from API types)
export const CONTACT_TITLE_LABELS: Record<ContactTitle, string> = {
  CEO: 'CEO',
  CTO: 'CTO',
  CFO: 'CFO',
  COO: 'COO',
  PRESIDENT: 'President',
  VP_SALES: 'VP Sales',
  VP_ENGINEERING: 'VP Engineering',
  VP_OPERATIONS: 'VP Operations',
  CONTROLLER: 'Controller',
  BOARD_MEMBER: 'Board Member',
  BOARD_OBSERVER: 'Board Observer',
  ADVISOR: 'Advisor',
  OTHER: 'Other',
}

// Generate options from the type-safe labels record
export const JOB_TITLE_OPTIONS = (
  Object.entries(CONTACT_TITLE_LABELS) as [ContactTitle, string][]
).map(([value, label]) => ({ value, label }))

export const addContactSchema = z
  .object({
    firstName: z.string().min(1, 'First name is required').max(255),
    lastName: z.string().max(255).optional().or(z.literal('')),
    email: z
      .string()
      .email('Invalid email address')
      .optional()
      .or(z.literal('')),
    phone: z
      .string()
      .max(50)
      .regex(
        /^[0-9+\-()\s]*$/,
        'Phone can only contain numbers, +, -, (, ), and spaces'
      )
      .optional()
      .or(z.literal('')),
    companyId: z.string().min(1, 'Company is required'),
    title: z.string().optional().or(z.literal('')),
    notes: z.string().optional().or(z.literal('')),
  })
  .refine((data) => !data.companyId || data.title, {
    message: 'Job title is required when a company is selected',
    path: ['title'],
  })

export type AddContactFormValues = z.infer<typeof addContactSchema>
